export default "__VITE_ASSET__BixLWL$j__"